import React, { useContext } from 'react';
import useContracts from '@ubeya/shared/hooks/account/useContracts';
import ConfigContext from '../../../contexts/ConfigContext';

const NO_CONTRACT_ID = 0;

const ContractsChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  const { mappedContracts = {} } = useContracts();
  const ids = Array.isArray(value) ? value : [value];

  const contractNames = ids
    .map((id) => {
      if (id === NO_CONTRACT_ID) {
        return t('none');
      }
      const contract = mappedContracts[id];
      return contract.isDeleted ? `${contract.name} (${t('deleted')})` : contract.name;
    })
    .filter(Boolean)
    .join(', ');
  return <>{contractNames}</>;
};

export default ContractsChip;
